var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"text-transform-none bold ma-0",attrs:{"color":"primary","dark":"","round":"","to":{ name: 'diagnostic', params: { domain: _vm.computedDomain } },"title":_vm.label}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }